var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative", attrs: { id: "chatbot-dashboard" } },
    [
      _vm.movingMode
        ? _c("MovePanel", { attrs: { changeMoveMode: _vm.changeMoveMode } })
        : _vm._e(),
      _vm._v(" "),
      _vm.copyingMode
        ? _c("CopyPanel", { attrs: { changeCopyMode: _vm.changeCopyMode } })
        : _vm._e(),
      _vm._v(" "),
      _vm.dragMode ? _c("DragPanel") : _vm._e(),
      _vm._v(" "),
      _c("FlowBreadCrumb", {
        attrs: {
          navigateTo: _vm.navigateToBlock,
          navigation: _vm.getNavigationDetail(),
          title: _vm.storyTitle,
          storyId: _vm.storyId,
          "preview-mode": _vm.previewMode,
          board: _vm.board,
        },
        on: {
          showAIKnowledge: function () {
            return (_vm.showAIKnowledge = true)
          },
        },
      }),
      _vm._v(" "),
      !_vm.dragMode
        ? _c("FooterToolbar", {
            attrs: {
              scale: _vm.scale,
              "focus-start-point": _vm.focusStartPoint,
              board: _vm.board,
              "story-id": _vm.storyId,
              "story-version": _vm.storyVersion,
              "preview-mode": _vm.previewMode,
            },
            on: {
              updateScale: function (e) {
                return (this$1.scale = e)
              },
              toggleMinimap: _vm.handleMinimapToggle,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.block && !_vm.movingMode && !_vm.copyingMode
        ? _c("Toolbar", {
            attrs: {
              dragMode: _vm.dragMode,
              dragStart: _vm.dragStart,
              dragEnd: _vm.dragEnd,
              addBlockToDiagram: _vm.addBlockToDiagram,
              flattedDiagram: _vm.flattedDiagram,
              blocksMetas: _vm.blocksMetas,
              "story-id": _vm.storyId,
              version: _vm.storyVersion,
              "test-start-block-id": _vm.testStartBlockId,
              diagram: _vm.board.diagram,
              board: _vm.board,
              "preview-mode": _vm.previewMode,
              navigateTo: _vm.navigateToBlock,
            },
            on: {
              openModal: _vm.openModal,
              setTranslate: function (e) {
                return this$1.updateTranslate(e, true)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.block && !_vm.movingMode && !_vm.copyingMode
        ? _c("BlockModal", {
            ref: "BlockModal",
            attrs: {
              block: _vm.block,
              storyId: _vm.storyId,
              storyVersion: _vm.storyVersion,
              flattedDiagram: _vm.flattedDiagram,
              "preview-mode": _vm.previewMode,
            },
            on: { close: _vm.closeModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addMenu
        ? _c("AddContextMenu", {
            attrs: {
              addMenuPos: _vm.addMenuPos,
              block: _vm.addBlock,
              addBlockToDiagram: _vm.addBlockToDiagram,
              navigation: _vm.getNavigationDetail(),
              storyId: _vm.storyId,
              storyVersion: _vm.storyVersion,
              showNotification: _vm.showNotification,
              flattedDiagram: _vm.flattedDiagram,
              blocksMetas: _vm.blocksMetas,
              getAllowedBlocks: _vm.getAllowedBlocks,
            },
            on: { closeContextMenu: _vm.closeModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { overflow: "hidden" } },
        [
          _vm.overlayVisible
            ? _c("div", {
                staticClass: "overlay",
                on: {
                  click: function ($event) {
                    return _vm.closeModal(false)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("DiagramViewer", {
            ref: "diagramViewer",
            attrs: {
              translate: _vm.translate,
              scale: _vm.scale,
              board: _vm.board,
              diagram: _vm.board.diagram,
              translating: _vm.translating,
              selectedBlock: !!_vm.block && _vm.block.id,
              navigation: _vm.getNavigationDetail(),
              navigateToBlock: _vm.navigateToBlock,
              storyId: _vm.storyId,
              storyVersion: _vm.storyVersion,
              movingMode: _vm.movingMode,
              movingBlock: _vm.movingBlock,
              changeMoveMode: _vm.changeMoveMode,
              moveBlock: _vm.moveBlock,
              copyingMode: _vm.copyingMode,
              copyingBlock: _vm.copyingBlock,
              changeCopyMode: _vm.changeCopyMode,
              copyBlock: _vm.copyBlock,
              flattedDiagram: _vm.flattedDiagram,
              showNotification: _vm.showNotification,
              dragMode: _vm.dragMode,
              addBlockToDiagram: _vm.addBlockToDiagram,
              draggingType: _vm.draggingType,
              "start-test-from-here": _vm.startTestFromHere,
              "test-state": _vm.chatWidgetOpened ? _vm.testState : null,
              "selected-block-id": _vm.selectedBlockId,
              "test-start-block-id": _vm.testStartBlockId,
              "preview-mode": _vm.previewMode,
              getAllowedBlocks: _vm.getAllowedBlocks,
            },
            on: {
              showAIKnowledge: function () {
                return (_vm.showAIKnowledge = true)
              },
              openContextMenu: _vm.openAddContext,
              updateScale: function (e) {
                return (this$1.scale = e)
              },
              updateTranslate: _vm.updateTranslate,
              setTranslate: function (e) {
                return this$1.updateTranslate(e, true)
              },
              openModal: _vm.openModal,
              blockMetasCalculated: function ($event) {
                return _vm.updateBlockMetas($event)
              },
            },
          }),
          _vm._v(" "),
          _vm.showAIKnowledge
            ? _c("AIKnowledge", {
                attrs: { storyId: _vm.storyId, storyTitle: _vm.storyTitle },
                on: {
                  close: function ($event) {
                    _vm.showAIKnowledge = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }